import React from "react";
import Select from "Jarvis/JarvisComponents/Select";
import { JobPositionTypeRetrieve } from "Jarvis/JarvisSystems/Pms/Services/JobPositionTypeService";

export default function JobPositionTypeSelect({
  control,
  label,
  name,
  serviceParams,
  ...rest
}) {
  return (
    <Select
      label={label}
      control={control}
      name={name}
      service={JobPositionTypeRetrieve}
      serviceParams={{
        ...serviceParams,
        retrieveAsList: true,
        isDeepSearchNeeded: true,
      }}
      displayFieldName="JobPositionTypeLangName"
      valueFieldName="JobPositionTypeId"
      selectOnFocus
      autoSelect
      typeOnly
      {...rest}
    />
  );
}
